// removed by extract-text-webpack-plugin
module.exports = {"barometerColor":"#FFBC4E","liveblogColor":"#43a5f5","playerlistColor":"#FE3F68","surveyColor":"#1367FB","predictorColor":"#1dd1a1"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/element_custom.scss
// module id = temA
// module chunks = 1